export const ASSIGNMENT_PROCESSING_STATUSES = {
    PROCESSING: 'n',
    READY: 'f',
    ERROR: 'exl',
    ADDING_FILES: 'af',
    PROJECTION: 'rp',
    UPLOADING: 'ca',
    REFINEMENT_INITIALIZING: 'ip',
}

export const AssignmentProcessingErrorMessages = {
    TRAINING_ERROR: 'Failed to train assignment',
    HIGHLIGHTS_AND_PROBABILITIES_ERROR: 'Failed to generate highlights and probabilities',
}
